/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { FancyAction } from 'src/app/common/fancy-firebase/base/FancyAction';
import { FancyActionableFirebase } from 'src/app/common/fancy-firebase/generics/FancyActionableFirebase';
import { OrganizationList } from 'src/app/common/fancy-firebase/lists/OrganizationList';
import { Organization } from '../models/Organization';
import { DefaultSplitDataRenderType } from '@touchplan/common';

export class OrganizationsApi extends FancyActionableFirebase<Organization, FancyAction, OrganizationList> {
	constructor(public data: OrganizationList) {
		super(data);
	}

	public addItem(initialData: object, idOverride?: string): void {
		const key = this.data.generateNewChildKey();
		const orgData = Object.assign({ organizationId: key }, initialData);
		super.addItem(orgData, key, false);

		const org = this.data.syncList.get(key);
		this.changeView(org, DefaultSplitDataRenderType.edit);
	}
}
